<header>
    {{ title }}
</header>
<section>
    {{ text }}
</section>
<footer>
    <div class="button green" mat-dialog-close>
        <span i18n>{{ label }}</span>
    </div>
</footer>
